/*
*
* File JS per il template Archive Video
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import heroBig from 'components/hero-big/hero-big';
import heroImage from 'imComponents/hero-image/hero-image';
import breadcrumbs from 'components/breadcrumbs/breadcrumbs';
import archiveFilters from 'components/archive-filters/archive-filters';
import cardVideoArchive from 'components/card-video-archive/card-video-archive';

import pagination from 'components/pagination/pagination';

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './archive-video.scss';

//--------------------------------------------------------------------//


// INIT COMPONENTI
//--------------------------------------------------------------------//

archiveFilters();

//--------------------------------------------------------------------//